// TeamPageSkeleton.jsx — mirrors the real team page so the swap doesn't jump
import React from "react";
import "./teamPageSkeleton.css";

const TeamPageSkeleton = () => {
	return (
		<div className="sf-tm-page sf-tm-skel">
			<div className="sf-tm-content">
				{/* Header */}
				<div className="sf-tm-head">
					<div className="sf-tm-head-row">
						<div className="sf-tm-head-copy">
							<div className="sf-tms-box sf-tms-eyebrow" />
							<div className="sf-tms-box sf-tms-title" />
							<div className="sf-tms-box sf-tms-subtitle" />
						</div>
						<div className="sf-tms-box sf-tms-manage" />
					</div>

					{/* <div className="sf-tm-stats">
						{Array.from({ length: 3 }).map((_, i) => (
							<div className="sf-tms-stat" key={i}>
								<div className="sf-tms-box sf-tms-stat-num" />
								<div className="sf-tms-box sf-tms-stat-label" />
							</div>
						))}
					</div> */}
				</div>

				<div className="sf-tm-body">
					{/* Roster */}
					<div className="sf-tm-rail">
						<div className="sf-tms-head">
							<div className="sf-tms-box sf-tms-h2" />
						</div>
						<div className="sf-tms-roster">
							{Array.from({ length: 5 }).map((_, i) => (
								<div className="sf-tms-card" key={i}>
									<div className="sf-tms-box sf-tms-card-avatar" />
									<div className="sf-tms-card-body">
										<div className="sf-tms-box sf-tms-card-name" />
										<div className="sf-tms-box sf-tms-card-email" />
										<div className="sf-tms-box sf-tms-card-chip" />
									</div>
								</div>
							))}
						</div>
					</div>

					{/* Selected profile */}
					<div className="sf-tm-detail">
						<div className="sf-tms-head">
							<div className="sf-tms-box sf-tms-h2" />
						</div>

						<div className="sf-tms-profile">
							<div className="sf-tms-profile-head">
								<div className="sf-tms-box sf-tms-avatar" />
								<div className="sf-tms-profile-copy">
									<div className="sf-tms-box sf-tms-name" />
									<div className="sf-tms-box sf-tms-badge" />
								</div>
							</div>

							<div className="sf-tms-contact">
								{Array.from({ length: 2 }).map((_, i) => (
									<div className="sf-tms-contact-row" key={i}>
										<div className="sf-tms-box sf-tms-contact-icon" />
										<div className="sf-tms-box sf-tms-contact-text" />
									</div>
								))}
							</div>
						</div>

						{/* Services */}
						<div className="sf-tms-head sf-tms-head--spaced">
							<div className="sf-tms-box sf-tms-h2" />
						</div>
						<div className="sf-tms-card-block">
							<div className="sf-tms-card-head">
								<div className="sf-tms-box sf-tms-cat" />
							</div>
							{Array.from({ length: 3 }).map((_, i) => (
								<div className="sf-tms-row" key={i}>
									<div className="sf-tms-row-copy">
										<div className="sf-tms-box sf-tms-line-lg" />
										<div className="sf-tms-box sf-tms-line-sm" />
									</div>
									<div className="sf-tms-box sf-tms-price" />
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TeamPageSkeleton;
